// https://www.appsloveworld.com/reactjs/100/11/react-router-v6-navigate-outside-of-components
// idea is to make a custom router that instantiates the history state in the same manner as RRDv6 routers.
// instead of this solution we could use import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom" and inject custom history object from package "history" -> history.ts file, but as it says in link above: "API is currently prefixed as unstable_ because you may unintentionally add two versions of the history library to your app, the one you have added to your package.json and whatever version React Router uses internally. Once we have a mechanism to detect mis-matched versions, this API will remove its unstable_ prefix."
// when react-router-dom team fix this we can stop using this CustomRouter and add custom history instance directly in react-router-dom like described in "Update" section
// main purpose for making this is for custom popup modal, in file useBlocker.ts we have .block() function, in newer versions of react-router-dom they threw out that function internally in React Router history instance, so we add our custom history instance which have that block() function for normally work

import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { History } from 'history';

export const CustomRouter = ({ history, ...props }: { history: History; props: any }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};
